import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Button } from 'reactstrap'
import { connect } from 'react-redux'
import ConfirmationModal from '../../../common/modal/ConfirmationModal'
import { deleteCabinCrewMovementHistory } from '../../../../actions'

const DeleteCabinCrewMovementHistoryButton = ({
  cabinCrewMovementHistoryId,
  dispatchDeleteCabinCrewMovementHistory
}) => {
  const [showWarningModal, setShowWarningModal] = useState(false)

  const closeModal = () => setShowWarningModal(false)

  const handleDelete = () => {
    dispatchDeleteCabinCrewMovementHistory(cabinCrewMovementHistoryId)
    closeModal()
  }

  return (
    <>
      <ConfirmationModal
        show={showWarningModal}
        onClickConfirm={handleDelete}
        onClickCancel={closeModal}
      />
      <Button color="danger" onClick={() => setShowWarningModal(true)} className="mr-2">
        Eliminar
      </Button>
    </>
  )
}

DeleteCabinCrewMovementHistoryButton.propTypes = {
  cabinCrewMovementHistoryId: PropTypes.string.isRequired,
  dispatchDeleteCabinCrewMovementHistory: PropTypes.func.isRequired,
}

const mapDispatchToProps = {
  dispatchDeleteCabinCrewMovementHistory: deleteCabinCrewMovementHistory
}

export default connect(null, mapDispatchToProps)(DeleteCabinCrewMovementHistoryButton)